export default {
  methods: {
    showField(id) {
      return true
    },
  },
}
